const config = {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    apiVersion:process.env.VUE_APP_API_VERSION,
    apiUrl:process.env.VUE_APP_API_BASE_URL+process.env.VUE_APP_API_VERSION,
    passwordHistoryDepth: parseInt(process.env.VUE_APP_PASSWORD_HISTORY_DEPTH) || 5,
}
  
  export default config;